module.exports = "<div id=\"dashboard\" class=\"step slide\" :data-x=\"index\" data-y=\"0\">\n    <div class=\"inner-step\" v-if=\"isLoggedToDashboard\">\n        <iframe id=\"analytics-iframe\"\n                name=\"demo\"\n                :src=\"analyticsDemoUrl\"\n                class=\"inner-site\"\n                frameborder=\"0\">\n        </iframe>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/dashboard/dashboard.html
// module id = 68
// module chunks = 0